export enum FaqScreenState {
  ViewAdminAppFaqs = 1,
  EditFaqs = 2,
  ManageGameFaqs = 3
}
